/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { mFIGetLeaseLookupByCustomerAsync } from './progressive-proxy-files/ProgressiveDataActionExtension.g';
import { ILeaseLookup, IMFILeaseLookupByCustomerResponse } from './progressive-proxy-files/ProgressiveDataServiceEntities.g';

/**
 * ProgressiveLeaselookupbycustomer Input Action
 */
export class ProgressiveLeaselookupbycustomerInput implements Msdyn365.IActionInput {
    public phoneNumber?: string;
    public ssn?: string;
    public tenderType?: string;
    public checkoutType?: string;
    constructor(phoneNumber?: string | undefined, ssn?: string | undefined, tenderType?: string, checkoutType?: string) {
        this.phoneNumber = phoneNumber;
        this.ssn = ssn;
        this.tenderType = tenderType;
        this.checkoutType = checkoutType;
    }
    public getCacheKey = () => `progressiveLeaselookupbycustomer`;
    public getCacheObjectType = () => 'progressiveLeaselookupbycustomer';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// Progressive Leaselookup by custome: Create a data model here or import one to capture the response of the action
export interface IProgressiveLeaselookupbycustomerData {
    text: string;
}
/**
 * Progressive Leaselookup by custome: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new ProgressiveLeaselookupbycustomerInput();
};

/**
 * progressiveLeaselookupbycustomer: Use this function to call your action and process the results as needed
 */
async function progressiveLeaselookup(
    input: ProgressiveLeaselookupbycustomerInput,
    ctx: Msdyn365.IActionContext
): Promise<ILeaseLookup | null> {
    const inputData = {
        MobilePhoneNumber: input.phoneNumber?.replace(/\D/g, ''),
        Last4SSN: input.ssn,
        TenderType: input.tenderType,
        TransactionType: input.checkoutType
    };

    try {
      const response: IMFILeaseLookupByCustomerResponse = await mFIGetLeaseLookupByCustomerAsync({ callerContext: ctx }, inputData);
      if (response.LeaseLookupByCustomer?.IsNoContent || !response.LeaseLookupByCustomer?.LeaseLookup) {
        return null;
      }
      return response.LeaseLookupByCustomer.LeaseLookup;
    } catch (error) {
        console.error('Progressive Leaselookup Error:', error);
        return null;
    }
}
export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ILeaseLookup>>progressiveLeaselookup,
    id: 'ProgressiveLeaselookupbycustomer',
    input: createInput
});
